import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBikeType, LazyMitraVehicle, LazyRoleBadge, LazySapaVehicle, LazySelfVehicle, LazyStatusBadge, LazyVehicleApproval, LazyVehicleApprovalText, LazyCardTripVehicle, LazyCardVehicleInfo, LazyCreateVehicleRequestForm, LazyEmployeeItem, LazyMaintenanceVehicleItem, LazyVehicelItem, LazyBottomSheetUploadSTNK, LazyModalApproveVehicleConfirmation, LazyModalApproveVehicleMaintenanceConfirmation, LazyModalBbmConfirmation, LazyModalChangeSelectedEmployeeConfirmation, LazyModalClaimBbmFilter, LazyModalCreateMaintenance, LazyModalCreateNewClaimBbm, LazyModalCreateNewVehicle, LazyModalCreateNewVehicleFromAnotherStore, LazyModalCreateNewVehicleRequestConfirmation, LazyModalCreateNewVehicleRequestQuitConfirmation, LazyModalDatePickerVehicle, LazyModalDetailClaimBbm, LazyModalDetailMaintenance, LazyModalDetailVehicleConfig, LazyModalInfoConfirmation, LazyModalMaintenanceFilter, LazyModalPreviewImage, LazyModalRegisteredVehicleFilter, LazyModalRejectSubmission, LazyModalRejectVehicleMaintenanceReason, LazyModalRejectVehicleReason, LazyModalTermAndCondition, LazyModalTripDetail, LazyModalVehicleActivation, LazyModalVehicleActivationReason, LazyModalVehicleConfigFilter, LazyModalVehicleDetail, LazyModalShowImage, LazyModalShowQR, LazySkeleton, LazyRegisteredVehicleTable, LazyVehicleBbmTable, LazyVehicleConfigTable, LazyVehicleMaintenanceTable, LazyDashboardTableContent, LazyHighlightInfo, LazyAppHeader, LazyDateRangeCalendar, LazyFilterModal, LazyProgressTrackingModal, LazySideNav, LazyDeliveryPerformance, LazyMonitoringPerformance, LazyPackingPerformance, LazyPodAllSla, LazyFilterRefund, LazyMonitoringRefund, LazyPopup, LazyRole, LazyActivityItem, LazyActivityLog, LazyAllDriverMap, LazyCrewCard, LazyCrewTracking, LazyFilterReport, LazyFilterSelect, LazyMapContent, LazyRealtimeTracking, LazyShipmentPopup, LazyThreePLCard, LazyTrackingReport, LazyTrackingReport3pl, LazyTrip3pl, LazyTripCard, LazyModalDateReport, LazyModalFilter, LazyBaseModal, LazyCardContainer, LazyCheckbox, LazyDatePicker, LazyDropUp, LazyEmptyData, LazyEmptyRegisteredVehicle, LazyEmptySubmission, LazyIcon, LazyLoading, LazyModalDatePicker, LazyModalDatePickerSingle, LazyPagination, LazyPopUpModal, LazyRefundEmpty, LazySortingButton, LazyTrackingEmpty } from '#components'
const lazyGlobalComponents = [
  ["BikeType", LazyBikeType],
["MitraVehicle", LazyMitraVehicle],
["RoleBadge", LazyRoleBadge],
["SapaVehicle", LazySapaVehicle],
["SelfVehicle", LazySelfVehicle],
["StatusBadge", LazyStatusBadge],
["VehicleApproval", LazyVehicleApproval],
["VehicleApprovalText", LazyVehicleApprovalText],
["CardTripVehicle", LazyCardTripVehicle],
["CardVehicleInfo", LazyCardVehicleInfo],
["CreateVehicleRequestForm", LazyCreateVehicleRequestForm],
["EmployeeItem", LazyEmployeeItem],
["MaintenanceVehicleItem", LazyMaintenanceVehicleItem],
["VehicelItem", LazyVehicelItem],
["BottomSheetUploadSTNK", LazyBottomSheetUploadSTNK],
["ModalApproveVehicleConfirmation", LazyModalApproveVehicleConfirmation],
["ModalApproveVehicleMaintenanceConfirmation", LazyModalApproveVehicleMaintenanceConfirmation],
["ModalBbmConfirmation", LazyModalBbmConfirmation],
["ModalChangeSelectedEmployeeConfirmation", LazyModalChangeSelectedEmployeeConfirmation],
["ModalClaimBbmFilter", LazyModalClaimBbmFilter],
["ModalCreateMaintenance", LazyModalCreateMaintenance],
["ModalCreateNewClaimBbm", LazyModalCreateNewClaimBbm],
["ModalCreateNewVehicle", LazyModalCreateNewVehicle],
["ModalCreateNewVehicleFromAnotherStore", LazyModalCreateNewVehicleFromAnotherStore],
["ModalCreateNewVehicleRequestConfirmation", LazyModalCreateNewVehicleRequestConfirmation],
["ModalCreateNewVehicleRequestQuitConfirmation", LazyModalCreateNewVehicleRequestQuitConfirmation],
["ModalDatePickerVehicle", LazyModalDatePickerVehicle],
["ModalDetailClaimBbm", LazyModalDetailClaimBbm],
["ModalDetailMaintenance", LazyModalDetailMaintenance],
["ModalDetailVehicleConfig", LazyModalDetailVehicleConfig],
["ModalInfoConfirmation", LazyModalInfoConfirmation],
["ModalMaintenanceFilter", LazyModalMaintenanceFilter],
["ModalPreviewImage", LazyModalPreviewImage],
["ModalRegisteredVehicleFilter", LazyModalRegisteredVehicleFilter],
["ModalRejectSubmission", LazyModalRejectSubmission],
["ModalRejectVehicleMaintenanceReason", LazyModalRejectVehicleMaintenanceReason],
["ModalRejectVehicleReason", LazyModalRejectVehicleReason],
["ModalTermAndCondition", LazyModalTermAndCondition],
["ModalTripDetail", LazyModalTripDetail],
["ModalVehicleActivation", LazyModalVehicleActivation],
["ModalVehicleActivationReason", LazyModalVehicleActivationReason],
["ModalVehicleConfigFilter", LazyModalVehicleConfigFilter],
["ModalVehicleDetail", LazyModalVehicleDetail],
["ModalShowImage", LazyModalShowImage],
["ModalShowQR", LazyModalShowQR],
["Skeleton", LazySkeleton],
["RegisteredVehicleTable", LazyRegisteredVehicleTable],
["VehicleBbmTable", LazyVehicleBbmTable],
["VehicleConfigTable", LazyVehicleConfigTable],
["VehicleMaintenanceTable", LazyVehicleMaintenanceTable],
["DashboardTableContent", LazyDashboardTableContent],
["HighlightInfo", LazyHighlightInfo],
["AppHeader", LazyAppHeader],
["DateRangeCalendar", LazyDateRangeCalendar],
["FilterModal", LazyFilterModal],
["ProgressTrackingModal", LazyProgressTrackingModal],
["SideNav", LazySideNav],
["DeliveryPerformance", LazyDeliveryPerformance],
["MonitoringPerformance", LazyMonitoringPerformance],
["PackingPerformance", LazyPackingPerformance],
["PodAllSla", LazyPodAllSla],
["FilterRefund", LazyFilterRefund],
["MonitoringRefund", LazyMonitoringRefund],
["Popup", LazyPopup],
["Role", LazyRole],
["ActivityItem", LazyActivityItem],
["ActivityLog", LazyActivityLog],
["AllDriverMap", LazyAllDriverMap],
["CrewCard", LazyCrewCard],
["CrewTracking", LazyCrewTracking],
["FilterReport", LazyFilterReport],
["FilterSelect", LazyFilterSelect],
["MapContent", LazyMapContent],
["RealtimeTracking", LazyRealtimeTracking],
["ShipmentPopup", LazyShipmentPopup],
["ThreePLCard", LazyThreePLCard],
["TrackingReport", LazyTrackingReport],
["TrackingReport3pl", LazyTrackingReport3pl],
["Trip3pl", LazyTrip3pl],
["TripCard", LazyTripCard],
["ModalDateReport", LazyModalDateReport],
["ModalFilter", LazyModalFilter],
["BaseModal", LazyBaseModal],
["CardContainer", LazyCardContainer],
["Checkbox", LazyCheckbox],
["DatePicker", LazyDatePicker],
["DropUp", LazyDropUp],
["EmptyData", LazyEmptyData],
["EmptyRegisteredVehicle", LazyEmptyRegisteredVehicle],
["EmptySubmission", LazyEmptySubmission],
["Icon", LazyIcon],
["Loading", LazyLoading],
["ModalDatePicker", LazyModalDatePicker],
["ModalDatePickerSingle", LazyModalDatePickerSingle],
["Pagination", LazyPagination],
["PopUpModal", LazyPopUpModal],
["RefundEmpty", LazyRefundEmpty],
["SortingButton", LazySortingButton],
["TrackingEmpty", LazyTrackingEmpty],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
